import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Card from '@material-ui/core/Card';


const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    tableHeader: {
        
    },
});

let id = 0;
function createData(taskId, title, description, assignedTo, statusT, remarks, link, timestamp) {
    id += 1;
    let status = { statusT, remarks, link }
    return { taskId, title, description, assignedTo, status, timestamp };
}

const rows = [
    createData(231, 'Task change', 'NULL', 'create "Please collect document A"', 'Create', "Please see attached latest doc for your perusal", "https://docs.google.com/document/export?format=docx&id=1M5oI4NLqiBd00C8yrwV9ecrEirh2CjPrN2bZhk4B5EM&token=AC4w5Vgc1Q0RkXu4UhG8sUzNFhP1CPVENw%3A1537411069092&ouid=116888327737613575152&includes_info_params=true", '14-SEP-18 16:00:02'),
    createData(325, 'Task change', 'task "Please collect document A"', 'delete "Please collect document A"', 'Create', null, null, '14-SEP-18 12:05:02'),
    createData(445, 'Status change', 'closed', 'approved', 'Delete', "Number of fatalities is 9956. Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum    at eros. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Cras    mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in,    egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.    Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis   lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia bibendum nulla    sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.    Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Cras mattis    consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in,    egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.    Praeent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis    lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia bibendum nulla    sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.    Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Cras mattis    consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in,    egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.    Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis    lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia bibendum nulla    sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.    Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Cras mattis    consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in,    egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.    Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis    lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia bibendum nulla    se consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.    Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Cras mattis    consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.", null, '14-SEP-18 11:20:02'),
    createData(667, 'Owner Change', 'Owner: Yongyi', 'Owenr: Jiajie', 'Edit', null, null, '13-SEP-18 18:00:02')
];

class TaskLogList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            scroll: 'paper',
            selectedTask: rows[0]
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    handleClickOpen = task => () => {
        console.log(task);
        this.setState({ open: true, selectedTask: task });
    };

    handleClose = () => {
        this.setState({ open: false });
    };
    render() {
        // console.log("now in log props");
        // console.log(this.props);
        const classes = this.props;
        const { selectedTask } = this.state;
        let i = 0;
        const dialog = (<Dialog
            open={this.state.open}
            onClose={this.handleClose}
            scroll={this.state.scroll}
            aria-labelledby="scroll-dialog-title"
        >
            <DialogTitle id="scroll-dialog-title">{selectedTask.title}</DialogTitle>
            <DialogContent style={{ width: "60vh", height: "30vh" }}>
                <DialogContentText>
                    {selectedTask.status.remarks}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" disabled={!selectedTask.status.link} href={selectedTask.status.link}>
                    Attachment
              </Button>
                <Button onClick={this.handleClose} color="primary">
                    Close
              </Button>
            </DialogActions>
        </Dialog>)
        const content_height = this.state.height - 139 + "px";
        return (
            <Card className={classes.root} style={{ textAlign: "left" , overflow: "scroll", height:content_height }}>
                {dialog}
                <Table className={classes.table} padding="dense">
                    <TableHead style={{textTransform: 'capitalize',}}>
                        <TableRow>
                            {this.props.header.map(header =>{
                                return(
                                    <TableCell>{header}</TableCell>
                                )
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.props.data.map(n => {
                            return (
                                <TableRow key={n.id}>
                                    {this.props.header.map(header =>{
                                            return(
                                                <TableCell>{n[header.replace(" ","_")]}</TableCell>
                                            );
                                        })
                                    }
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </Card>
        )
    }
}

TaskLogList.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TaskLogList);